import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import { Quote, StyledPressLogo, LogoContainer } from './styles';

export const PressLogo = ({ quote, fontColor, image }) => {
  return (
    <StyledPressLogo quote={quote}>
      <LogoContainer>
        <ResponsiveImage
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
        />
      </LogoContainer>
      {quote && <Quote $fontColor={fontColor}>{quote}</Quote>}
    </StyledPressLogo>
  );
};

PressLogo.displayName = 'PressLogo';

PressLogo.propTypes = {
  quote: PropTypes.string,
  fontColor: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
};
